import { Environment } from 'environments/environment.interface';

export const environment: Environment = {
  production: true,
  serverUrl: 'https://a.projcont.novin.hu',
  mockServerUrl: '',
  infoMessageDuration: 3,
};
